import * as React from "react"
import Box from "@mui/material/Box"
import Drawer from "@mui/material/Drawer"
import Button from "@mui/material/Button"
import {
  Divider,
  IconButton,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material"
import {
  DrawerBox,
  DrawerBoxHeading,
  Heading,
  TypoHeading,
  ModalHeadingRow,
  ModalHeadingCell,
  StyledTab,
} from "./Atom"
import ClearIcon from "@mui/icons-material/Clear"
import { TabContext, TabList, TabPanel } from "@mui/lab"

import OpportunityEventLogs from "../OpportunityEventLogs"

import OpportunityDetails from "../OpportunityDetails"
import { useSelector } from "react-redux"
import PermsWrapper from "../../../Auth/PermsWrapper"
import { permissions } from "../../../../../config/constants"
import { colors } from "../../../../../styles/commonStyles"
export default function OpportunityDrawer(props: any) {
  const {
    isDrawerOpen,
    setIsDrawerOpen,
    updateStatus,
    isDrawerOpenLogs,
    setIsDrawerOpenLogs,
    fetchMoreColumns,
    fetchOpportunityLogs,
  } = props

  const allPerms = useSelector((state: any) => {
    return state.rolesAndPerms.userPerms
  })
  const [hadAccess, setHadAccess] = React.useState(false)
  const [value, setValue] = React.useState("1")

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue)
  }

  const officeName = useSelector((state: any) => {
    return state.metric.officeName
  })
  const opportunityName = useSelector((state: any) => {
    return state.metric.opportunityName
  })
  const opportunityStatus = useSelector((state: any) => {
    return state.metric.opportunityStatus
  })

  React.useEffect(() => {
    if (isDrawerOpen) {
      fetchMoreColumns()
      fetchOpportunityLogs()
    }
  }, [isDrawerOpen])

  return (
    <div>
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        hideBackdrop={true}
      >
        <DrawerBox>
          <TabContext value={value}>
            <DrawerBoxHeading>
              {/* <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab
                  sx={{ padding: 0 }}
                  label={
                    <>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: "900",
                          padding: " 20px 0px",
                          color: "#000",
                          textTransform: "capitalize",
                        }}
                      >
                        Opportunity Details
                      </Typography>
                    </>
                  }
                  value="1"
                />

                <Tab
                  sx={{ padding: 0 }}
                  label={
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "900",
                        padding: "20px 0px",
                        color: "#000",
                        textTransform: "capitalize",
                      }}
                    >
                      Logs
                    </Typography>
                  }
                  value="2"
                  onClick={(event) => {
                    setIsDrawerOpenLogs(true)
                  }}
                />
              </TabList> */}
              <TabList
                aria-label="Tabs"
                onChange={handleChange}
                TabIndicatorProps={{
                  sx: { maxWidth: "34px", height: "4px" },
                }}
              >
                <StyledTab
                  label={
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "900",
                        color: "#000",
                        textTransform: "capitalize",
                      }}
                    >
                      Opportunity Details
                    </Typography>
                  }
                  value="1"
                  disableRipple
                />
                {/* <PermsWrapper perm={permissions.OPPORTUNITY_VIEW_LOGS}>
                  <StyledTab
                    label={
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: "900",
                          color: "#000",
                          textTransform: "capitalize",
                          padding: "1px",
                        }}
                      >
                        Logs&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </Typography>
                    }
                    value="2"
                    disableRipple
                    onClick={(event: any) => {
                      setIsDrawerOpenLogs(true)
                    }}
                  />
                </PermsWrapper> */}
                <StyledTab
                  label={
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "900",
                        color: "#000",
                        textTransform: "capitalize",
                        padding: "1px",
                      }}
                    >
                      Logs&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </Typography>
                  }
                  value="2"
                  disableRipple
                  onClick={(event: any) => {
                    setIsDrawerOpenLogs(true)
                  }}
                />
              </TabList>
              <IconButton
                sx={{ padding: "20px 0px", color: "#000" }}
                disableRipple
                onClick={() => {
                  setIsDrawerOpen(false)
                  setValue("1")
                }}
              >
                <ClearIcon />
              </IconButton>
            </DrawerBoxHeading>
            <Divider />
            <TabPanel sx={{ padding: 0 }} value="1">
              <OpportunityDetails
                opportunityName={opportunityName}
                officeName={officeName}
                opportunityStatus={opportunityStatus}
                updateStatus={updateStatus}
              />
            </TabPanel>
            <TabPanel value="2" sx={{ padding: 0 }}>
              <OpportunityEventLogs
                isDrawerOpenLogs={isDrawerOpenLogs}
                setIsDrawerOpenLogs={setIsDrawerOpenLogs}
              />
            </TabPanel>
          </TabContext>
        </DrawerBox>
      </Drawer>
    </div>
  )
}
